import React from 'react';
import {Project} from "../../types/Project";
import {firstUrlFromDensitySrcset} from "../../utils/densitySrcset";

type Props = {
    project: Project
    index: number,
    isMobile: boolean,
    onProjectClick: () => void
}

/**
 * Carte projet (vue grille) : image responsive avec srcset densité 1x/2x
 * fourni par le JSON Fusion (TC.Website:DensityImageSrcset).
 */
const ProjectsListGridItem: React.FC<Props> = ({project, index, isMobile, onProjectClick}) => {
    let itemClasses = 'project-item projects-list-grid-item'
    if (project.newLoad) {
        itemClasses += ' hidden'
        project.newLoad = false
    }

    const tag = project.tags.length ? project.tags[0]?.title : ''

    const image = isMobile ? project.gridWideImage : index === 0 ? project.gridWideImage : project.gridImage

    return (
        <div className={itemClasses}>
            <a href={project.url} onClick={onProjectClick}>
                <div className={'project-image-wrapper'}>
                    <div className={'project-image'}>
                        <picture>
                            {/* srcSet = chaîne "url 1x, url 2x" déjà assemblée côté Fusion */}
                            <source srcSet={image.xxl} media={'(min-width: 1400px)'}/>
                            <source srcSet={image.xl} media={'(max-width: 1399px)'}/>
                            <source srcSet={image.lg} media={'(max-width: 1199px)'}/>
                            <source srcSet={image.md} media={'(max-width: 991px)'}/>
                            <source srcSet={image.sm} media={'(max-width: 767px)'}/>
                            <source srcSet={image.xs} media={'(max-width: 575px)'}/>
                            <img loading={'lazy'} src={firstUrlFromDensitySrcset(image.xxl)} alt={project.title}/>
                        </picture>
                    </div>
                </div>

                <div className={'project-content-wrapper'}>
                    <div className={'title-tag-wrapper'}>
                        <div className={'project-tag'}>
                            <span>#{tag}</span>
                        </div>

                        <h3 className={'project-title'}>{project.title}</h3>
                    </div>

                    {index === 0 &&
                        <div className={'project-description-wrapper'}>
                            <div className={'project-description'} dangerouslySetInnerHTML={{ __html: project.description || '' }}></div>
                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M59.0001 20V38C59.0001 38.2652 58.8947 38.5196 58.7072 38.7071C58.5196 38.8946 58.2653 39 58.0001 39C57.7349 39 57.4805 38.8946 57.293 38.7071C57.1054 38.5196 57.0001 38.2652 57.0001 38V22.415L30.7076 48.7075C30.6147 48.8005 30.5044 48.8742 30.383 48.9246C30.2616 48.9749 30.1315 49.0008 30.0001 49.0008C29.8687 49.0008 29.7385 48.9749 29.6171 48.9246C29.4957 48.8742 29.3854 48.8005 29.2926 48.7075L5.29257 24.7075C5.10493 24.5199 4.99951 24.2654 4.99951 24C4.99951 23.7346 5.10493 23.4801 5.29257 23.2925C5.48021 23.1049 5.7347 22.9994 6.00007 22.9994C6.26543 22.9994 6.51993 23.1049 6.70757 23.2925L30.0001 46.585L55.5851 21H40.0001C39.7349 21 39.4805 20.8946 39.293 20.7071C39.1054 20.5196 39.0001 20.2652 39.0001 20C39.0001 19.7348 39.1054 19.4804 39.293 19.2929C39.4805 19.1054 39.7349 19 40.0001 19H58.0001C58.2653 19 58.5196 19.1054 58.7072 19.2929C58.8947 19.4804 59.0001 19.7348 59.0001 20Z"/>
                            </svg>

                        </div>
                    }
                </div>
            </a>
        </div>
    )
}

export default ProjectsListGridItem
